import { ComponentPropsWithRef } from "react";

export const DotButton = (props: ComponentPropsWithRef<"button">) => {
  const { children, ...restProps } = props;

  return (
    <button type="button" {...restProps}>
      {children}
    </button>
  );
};
